import { render } from "./AboutPopular.vue?vue&type=template&id=37e07512"
import script from "./AboutPopular.vue?vue&type=script&lang=js"
export * from "./AboutPopular.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__